// third-party
import { combineReducers } from 'redux';

// project-imports
import menu from './menu';
import snackbar from './snackbar';

// ==============================|| COMBINE REDUCERS ||============================== //
//
// Only what the shell needs. Auth state lives in `contexts/AuthContext`, and every page owns its
// own data through `useApiQuery`, so nothing else has to be global.

const reducers = combineReducers({
  menu,
  snackbar
});

export default reducers;
